import { z } from 'zod';
import { dataOraSchema, dataSchema, idSchema, paginationQuerySchema } from '../common';
import { CategoriaAudit } from './enums';

/**
 * Quanto resta una riga nel registro prima che il job notturno la poti. Vale
 * per `audit_log`, non per `file_log`: lo storico di un file è parte della
 * pratica e segue la vita del file.
 */
export const GIORNI_CONSERVAZIONE_AUDIT = 90;

/** Filtri della consultazione del registro: le righe più recenti per prime. */
export const auditLogQuerySchema = paginationQuerySchema.extend({
  categoria: CategoriaAudit.optional(),
  /** Chi ha compiuto l'azione (anche un utente oggi disattivato). */
  utenteId: idSchema.optional(),
  /** Estremi inclusi, in giorni di calendario italiani. */
  dal: dataSchema.optional(),
  al: dataSchema.optional(),
});
export type AuditLogQuery = z.infer<typeof auditLogQuerySchema>;

export const auditLogVoceSchema = z.object({
  id: idSchema,
  /**
   * Codice dell'azione. È `string` e non `AzioneAudit`: una riga scritta con
   * un'azione poi ritirata dal catalogo resta consultabile.
   */
  azione: z.string(),
  entita: z.string().nullable(),
  entitaId: idSchema.nullable(),
  /** Chi l'ha compiuta; `null` per i tentativi di accesso con un'email sconosciuta. */
  utente: z.object({ id: idSchema, nome: z.string(), cognome: z.string() }).nullable(),
  /**
   * Contesto dell'azione, fotografato al momento in cui è avvenuta: `soggetto`
   * è il nome leggibile di ciò su cui si è agito (ragione sociale, nome del
   * ruolo, nome della fase…), perché dopo un'eliminazione non c'è più una riga
   * da cui ricavarlo.
   */
  dettagli: z.record(z.string(), z.unknown()).nullable(),
  creatoIl: dataOraSchema,
});
export type AuditLogVoce = z.infer<typeof auditLogVoceSchema>;
